import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { Region } from 'constants/enums';
import {
  INIT_DATE_LOCAL_STORAGE_ITEM_NAME,
  USER_NAME_LOCAL_STORAGE_KEY
} from 'constants/uiSettings';

dayjs.extend(utc);

interface AuthStorageData {
  token: string;
  region: Region;
}

export const authStorage = {
  setAuthData: ({ token, region }: AuthStorageData): void => {
    localStorage.setItem('token', token);
    localStorage.setItem('region', region);
    localStorage.setItem(
      INIT_DATE_LOCAL_STORAGE_ITEM_NAME,
      dayjs.utc().toISOString()
    );
  },

  getAuthData: (): { token: string | null; region: Region | null } => {
    const token = localStorage.getItem('token');
    const region = localStorage.getItem('region') as Region | null;

    return { token, region };
  },

  isAuthenticated: (): boolean => {
    const { token } = authStorage.getAuthData();
    return !!token;
  },

  clearAuthData: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('region');
    localStorage.removeItem(INIT_DATE_LOCAL_STORAGE_ITEM_NAME);
    localStorage.removeItem(USER_NAME_LOCAL_STORAGE_KEY);
  }
};
